import dayjs from 'dayjs';
import relativeTime from 'dayjs/plugin/relativeTime';

dayjs.extend(relativeTime);

/** One date format for every admin table and detail view. */
export const DATE_FORMAT = 'YYYY-MM-DD';
export const DATE_TIME_FORMAT = 'YYYY-MM-DD HH:mm';

const valid = (value) => value !== null && value !== undefined && value !== '' && dayjs(value).isValid();

export const formatDate = (value) => (valid(value) ? dayjs(value).format(DATE_FORMAT) : '-');

export const formatDateTime = (value) => (valid(value) ? dayjs(value).format(DATE_TIME_FORMAT) : '-');

/** "3 hours ago" — for queues where age matters more than the exact time. */
export const fromNow = (value) => (valid(value) ? dayjs(value).fromNow() : '-');
